import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "font-medium text-lg" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "font-medium text-lg" }
const _hoisted_6 = { class: "text-sm" }
const _hoisted_7 = { class: "text-sm" }

import type { Challenge, JobPosting } from "@/api/models/types";
import ArrowFrontIcon from "@/assets/icons/arrow-front.svg";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostingDetailLink',
  props: {
    posting: {}
  },
  setup(__props: any) {

const props = __props;



const jobPosting = computed(() =>
  props.posting.__typename === "JobPosting" ? props.posting : null
);
const challenge = computed(() => (props.posting.__typename === "Challenge" ? props.posting : null));

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.posting.company)
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: {
      name: jobPosting.value ? 'JobPostingDetail' : 'ChallengeDetail',
      params: { slug: _ctx.posting.slug },
    },
        class: "hover:text-primary-1 transition-colors underline"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h3", _hoisted_1, [
            _createTextVNode(_toDisplayString(_ctx.posting.displayTitle) + " ", 1),
            _createVNode(_unref(ArrowFrontIcon), { class: "xl:w-5 w-8 mr-2 xl:mr-1 mb-1 shrink-0 inline-block" })
          ]),
          (challenge.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(challenge.value.challengeType.name), 1))
            : _createCommentVNode("", true),
          (jobPosting.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _createTextVNode(_toDisplayString(jobPosting.value.company.name) + " ", 1),
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(jobPosting.value.company.zip) + " " + _toDisplayString(jobPosting.value.company.city), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to"]))
    : (challenge.value?.company)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: {
      name: 'CompanyDetail',
      params: { slug: challenge.value.company.slug },
    },
          class: "hover:text-primary-1 transition-colors underline"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h3", _hoisted_5, [
              _createTextVNode(_toDisplayString(challenge.value.displayTitle) + " ", 1),
              _createVNode(_unref(ArrowFrontIcon), { class: "xl:w-5 w-8 mr-2 xl:mr-1 mb-1 shrink-0 inline-block" })
            ]),
            _createElementVNode("p", _hoisted_6, _toDisplayString(challenge.value.challengeType.name), 1),
            _createElementVNode("p", _hoisted_7, _toDisplayString(challenge.value.company.name), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true)
}
}

})